import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.1.0/dist/cookieconsent.umd.js';

CookieConsent.run({

    guiOptions: {
        consentModal: {
            layout: 'cloud inline',
            position: 'bottom center',
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: true,
            flipButtons: false
        }
    },

    categories: {
        necessary: {
            enabled: true,
            readOnly: true
        },
        analytics: {
            autoClear: {
                cookies: [
                    { name: /^_ga/ },
                    { name: '_gid' }
                ]
            }
        },
        marketing: {}
    },

    language: {
        default: 'en',
        autoDetect: 'document',
        translations: {
            en: {
                consentModal: {
                    title: 'We use cookies',
                    description: 'We use cookies to ensure the proper functioning of our website, to personalize content and ads, and to analyze our traffic. You can manage your preferences below.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage preferences',
                    footer: '<a href="/policies/privacy-policy">Privacy Policy</a>'
                },
                preferencesModal: {
                    title: 'Cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save preferences',
                    closeIconLabel: 'Close',
                    sections: [
                        {
                            title: 'Cookie usage',
                            description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience.'
                        },
                        {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Analytics cookies',
                            description: 'These cookies collect information about how you use our website. All data is anonymized.',
                            linkedCategory: 'analytics'
                        },
                        {
                            title: 'Marketing cookies',
                            description: 'These cookies are used to make advertising messages more relevant to you.',
                            linkedCategory: 'marketing'
                        },
                        {
                            title: 'More information',
                            description: 'For any queries regarding our cookie policy, please <a href="/pages/contact">contact us</a>.'
                        }
                    ]
                }
            },
            el: {
                consentModal: {
                    title: 'Χρησιμοποιούμε cookies',
                    description: 'Χρησιμοποιούμε cookies για τη σωστή λειτουργία του ιστοτόπου μας, για την εξατομίκευση περιεχομένου και διαφημίσεων και για την ανάλυση της επισκεψιμότητάς μας.',
                    acceptAllBtn: 'Αποδοχή όλων',
                    acceptNecessaryBtn: 'Απόρριψη όλων',
                    showPreferencesBtn: 'Διαχείριση προτιμήσεων',
                    footer: '<a href="/policies/privacy-policy">Πολιτική Απορρήτου</a>'
                },
                preferencesModal: {
                    title: 'Προτιμήσεις cookies',
                    acceptAllBtn: 'Αποδοχή όλων',
                    acceptNecessaryBtn: 'Απόρριψη όλων',
                    savePreferencesBtn: 'Αποθήκευση προτιμήσεων',
                    closeIconLabel: 'Κλείσιμο',
                    sections: [
                        {
                            title: 'Χρήση cookies',
                            description: 'Χρησιμοποιούμε cookies για τη βασική λειτουργία του ιστοτόπου και τη βελτίωση της εμπειρίας σας.'
                        },
                        {
                            title: 'Απαραίτητα cookies',
                            description: 'Αυτά τα cookies είναι απαραίτητα για τη σωστή λειτουργία του ιστοτόπου.',
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Cookies ανάλυσης',
                            description: 'Αυτά τα cookies συλλέγουν ανώνυμες πληροφορίες σχετικά με τη χρήση του ιστοτόπου.',
                            linkedCategory: 'analytics'
                        },
                        {
                            title: 'Cookies μάρκετινγκ',
                            description: 'Αυτά τα cookies χρησιμοποιούνται για πιο σχετικές διαφημίσεις.',
                            linkedCategory: 'marketing'
                        },
                        {
                            title: 'Περισσότερες πληροφορίες',
                            description: 'Για ερωτήσεις σχετικά με τα cookies, <a href="/pages/contact">επικοινωνήστε μαζί μας</a>.'
                        }
                    ]
                }
            },
            ro: {
                consentModal: {
                    title: 'Folosim cookie-uri',
                    description: 'Folosim cookie-uri pentru funcționarea corectă a site-ului, pentru personalizarea conținutului și reclamelor și pentru analiza traficului nostru.',
                    acceptAllBtn: 'Acceptă toate',
                    acceptNecessaryBtn: 'Respinge toate',
                    showPreferencesBtn: 'Gestionează preferințele',
                    footer: '<a href="/policies/privacy-policy">Politica de confidențialitate</a>'
                },
                preferencesModal: {
                    title: 'Preferințe cookie-uri',
                    acceptAllBtn: 'Acceptă toate',
                    acceptNecessaryBtn: 'Respinge toate',
                    savePreferencesBtn: 'Salvează preferințele',
                    closeIconLabel: 'Închide',
                    sections: [
                        {
                            title: 'Utilizarea cookie-urilor',
                            description: 'Folosim cookie-uri pentru funcționalitatea de bază și îmbunătățirea experienței dumneavoastră.'
                        },
                        {
                            title: 'Cookie-uri necesare',
                            description: 'Aceste cookie-uri sunt esențiale pentru funcționarea corectă a site-ului.',
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Cookie-uri de analiză',
                            description: 'Aceste cookie-uri colectează informații anonime despre utilizarea site-ului.',
                            linkedCategory: 'analytics'
                        },
                        {
                            title: 'Cookie-uri de marketing',
                            description: 'Aceste cookie-uri sunt folosite pentru reclame mai relevante.',
                            linkedCategory: 'marketing'
                        },
                        {
                            title: 'Mai multe informații',
                            description: 'Pentru întrebări privind cookie-urile, <a href="/pages/contact">contactați-ne</a>.'
                        }
                    ]
                }
            }
        }
    }
});